// extracted by mini-css-extract-plugin
export default {"container":"ResetKeyModal_container__N9806","description":"ResetKeyModal_description__xx8ax","prefix":"ResetKeyModal_prefix__W304S"};